import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const body = new URLSearchParams();
      body.append('email', email);
      await fetch('https://readdy.ai/api/form/d7dqkipnoju8nk5a1ek0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
      setEmail('');
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <img
                src="https://static.readdy.ai/image/751042991eee80e3d0f5ce87d83ca658/ecd9c2a833b45c83e224d75a48614e57.png"
                alt="JoyaGoo Coupon"
                className="h-8 w-auto object-contain"
              />
              <span className="font-bold text-gray-900">JoyaGoo Coupon</span>
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed mb-5">
              Your #1 source for verified joyagoo coupon codes, promo deals, and shopping guides. Save more on every order.
            </p>
            <a
              href="https://repsw2c.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-orange-500 text-white text-sm font-semibold rounded-lg hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-store-2-line"></i>
              Visit Main Store
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4 text-sm uppercase tracking-wide">Quick Links</h3>
            <ul className="space-y-2.5">
              {[
                { label: 'Coupon Codes', to: '/joyagoo-coupon-code' },
                { label: 'Promo Codes', to: '/joyagoo-promo-code' },
                { label: 'Joyagoo Review', to: '/joyagoo-review' },
                { label: 'Shipping Guide', to: '/joyagoo-shipping' },
                { label: 'How to Use', to: '/how-to-use-joyagoo' },
                { label: 'Spreadsheet', to: '/joyagoo-spreadsheet' },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-gray-500 hover:text-orange-500 transition-colors cursor-pointer flex items-center gap-1.5">
                    <i className="ri-arrow-right-s-line text-orange-400"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4 text-sm uppercase tracking-wide">Categories</h3>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-gray-500 hover:text-orange-500 transition-colors cursor-pointer flex items-center gap-1.5"
                  >
                    <i className="ri-arrow-right-s-line text-orange-400"></i>
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4 text-sm uppercase tracking-wide">Get Exclusive Deals</h3>
            <p className="text-sm text-gray-500 mb-4 leading-relaxed">
              Subscribe to get the latest joyagoo coupon codes and deals delivered to your inbox.
            </p>
            {submitted ? (
              <div className="flex items-center gap-2 text-green-600 text-sm font-medium">
                <i className="ri-checkbox-circle-line text-lg"></i>
                Thanks! You&apos;re subscribed.
              </div>
            ) : (
              <form onSubmit={handleSubmit} data-readdy-form className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  required
                  className="flex-1 px-3 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:border-orange-400 bg-white"
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="w-10 h-10 flex items-center justify-center bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors cursor-pointer flex-shrink-0"
                >
                  <i className="ri-send-plane-line text-sm"></i>
                </button>
              </form>
            )}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-400">
            &copy; 2026 JoyaGoo Coupon (joyagoocoupon.net). All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/joyagoo-coupon-code" className="text-xs text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">Coupon Codes</Link>
            <Link to="/joyagoo-review" className="text-xs text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">Reviews</Link>
            <a href="https://repsw2c.com/" target="_blank" rel="noopener noreferrer nofollow" className="text-xs text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">Main Store</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
